import cogoToast from "cogo-toast";
import { createSlice } from "@reduxjs/toolkit";
import { t } from "i18next";

const couponSlice = createSlice({
  name: "coupon",
  initialState: {
    coupon: null,
  },
  reducers: {
    addToCoupon(state, action) {
      state.coupon = action.payload;
      if (!state.coupon) {
        cogoToast.error(t("discount_denied"), {
          heading: t("coupon_code"),
          position: "bottom-center",
        });
        return;
      }
      cogoToast.success(t("discount_applied"), {
        heading: t("coupon_code"),
        position: "bottom-center",
      });
    },
  },
});

export const { addToCoupon } = couponSlice.actions;
export default couponSlice.reducer;
